// HTTP wrapper for destructive table actions (empty / truncate / drop).
// Admin-only on the backend.
import { api } from './api.js';

export async function tableAction(connectionId, database, table, action) {
  return api.post(
    `/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/tables/${encodeURIComponent(table)}/action`,
    { action },
  );
}
